
export default function DeleteConfirmModal({ categoryName, onClose, onConfirm }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
        {/* Icon */}
        <div className="p-6 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-delete-bin-line text-3xl text-red-600"></i>
          </div>
          
          <h2 className="text-xl font-bold text-gray-800 mb-2">
            Delete Category
          </h2>
          
          <p className="text-gray-600 text-sm mb-1">
            Are you sure you want to delete
          </p>
          <p className="text-gray-800 font-semibold text-base mb-4">
            "{categoryName}"?
          </p>
          
          <p className="text-gray-500 text-xs">
            This action cannot be undone. The category will be permanently removed.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 px-6 pb-6">
          <button
            onClick={onClose}
            className="flex-1 px-6 py-2.5 border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-6 py-2.5 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
